import PracticeBaseError from 'errors/PracticeBaseError';

export default class PracticeGroupPracticeError extends PracticeBaseError {
  practice_group_id: string[] = []
}